export const validateEmail = (emailId: string) =>
  /(.+)@(.+)\.(.+)$/.test(emailId);

export const validatePassword = (password: string) => password.length >= 6;
